export type ComputedTunnelStatus = "Up" | "Down" | "Unknown";

const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

export const getComputedTunnelStatus = (
  lastHandshake: string | null,
  nowMs = Date.now()
): ComputedTunnelStatus => {
  if (!lastHandshake) {
    return "Unknown";
  }

  const parsed = new Date(lastHandshake).getTime();
  if (!Number.isFinite(parsed)) {
    return "Unknown";
  }

  return nowMs - parsed <= FIFTEEN_MINUTES_MS ? "Up" : "Down";
};
